import type { Locale } from '../locale';
import de from './de.json';
import en from './en.json';

const messages: Record<Locale, Record<string, string>> = { de, en };

export default messages;
